import React, { useCallback } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { Address } from './types';
import countries from '../../utils/countries-list';

interface BillingAddressProps {
  value: Address;
  onChange: (address: Address) => void;
}

function BillingAddress({ value, onChange }: BillingAddressProps) {
  const handleAddressChanged = useCallback((event: any) => {
    const newAddress = { ...value };
    newAddress[event.target.name] = event.target.value;
    onChange(newAddress);
  }, [value, onChange]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <TextField
        size="small"
        label="Address 1"
        name="line1"
        required
        onChange={handleAddressChanged}
      />
      <TextField
        size="small"
        label="Address 2"
        name="line2"
        onChange={handleAddressChanged}
      />
      <TextField
        size="small"
        label="City"
        name="city"
        required
        onChange={handleAddressChanged}
      />
      <TextField
        size="small"
        label="State / Province / Region"
        name="state"
        required
        onChange={handleAddressChanged}
      />
      <FormControl size="small" required>
        <InputLabel>Country</InputLabel>
        <Select
          label="Country"
          name="country"
          defaultValue="US"
          onChange={handleAddressChanged}
        >
          {countries.map((country) => (
            <MenuItem key={country.code} value={country.code}>{country.label}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        size="small"
        label="Zip / Postal Code"
        name="postal_code"
        required
        onChange={handleAddressChanged}
      />
    </Box>
  );
}

export default BillingAddress;
